/**
 * @generated SignedSource<<15af6e83f63141b0a0561052f86c3a36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProgramSelectableItem_program$data = {
  readonly id: string;
  readonly imageURL: string | null | undefined;
  readonly length: number;
  readonly name: string;
  readonly " $fragmentType": "ProgramSelectableItem_program";
};
export type ProgramSelectableItem_program$key = {
  readonly " $data"?: ProgramSelectableItem_program$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProgramSelectableItem_program">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProgramSelectableItem_program",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "length",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageURL",
      "storageKey": null
    }
  ],
  "type": "Program",
  "abstractKey": null
};

(node as any).hash = "c646008de4bcb591bd8a45a778cac071";

export default node;
